import Vue from 'vue'
import svgs from '@/../svg'
import VueI18n from 'vue-i18n'
import DirectiveHtmlClass from '@/helpers/DirectiveHtmlClass'
import store from '@/store'
import { updateServiceConfig } from '@/service'
import { config, readFromComponentOptions, readFromHtmlJson } from '@/config'
import dayjs from '@/helpers/dayjs'

let initializedOnce = false

// plugins
Vue.use(VueI18n)
Vue.use(DirectiveHtmlClass)
Vue.mixin({
  methods: {
    formatPrice(value, mode = "long") {
      let prefix = ""
      if (mode == "long") {
        prefix = "CHF "
      }
      else if (mode == "html") {
        prefix = "CHF&nbsp;"
      }

      let v = +value || 0
      return prefix + v.toFixed(2)
    }
  }
})

let i18n = null

export default function (dom, opts) {
  const options = {
    ...opts
  }

  readFromHtmlJson()
  readFromComponentOptions(options)
  updateServiceConfig()

  // we try to initialize as late as possible
  if (!initializedOnce) {
    dayjs.locale(config.LANGUAGE)
    // register global components
    Object.entries(svgs)
      .forEach(([k, v]) => Vue.component(k, v))

    i18n = new VueI18n({
      locale: config.LANGUAGE
    })

    initializedOnce = true
  }

  // component specific translation
  if (options.i18n) {
    Object.entries(options.i18n)
      .forEach(([k, v]) => {
        i18n.mergeLocaleMessage(k, v)
      })
  }

  const page = new Vue({
    el: dom,
    i18n,
    store,
    data: {
      shared: options.sharedData,
      options
    },
    render (h, context) {
      return h(options.vueComponent, {})
    },
    created () {
      if (options.vueInit) {
        this.$store.dispatch(options.vueInit, {})
      }
    }
  })
  return page
}
